// Mock data for Reliable Brothers Multi-Services Inc.

export const companyInfo = {
  name: "Reliable Brothers Multi-Services Inc.",
  tagline: "For Every Dream, a Reliable Team.",
  description: "A parent company providing diverse, reliable services through our specialized subsidiary companies. From IT solutions to home care, auto detailing to party planning - we've got you covered.",
  phone: "709-693-6634",
  email: "info@reliablebrothers.ca",
  address: "St. John's, NL, Canada"
};

export const services = [
  {
    id: 1,
    name: "Reliable IT Solutions",
    description: "IT services and digital solutions for businesses and homes, from AI integration to software, web and mobile app development.",
    icon: "Monitor",
    features: ["AI Integration", "Web & App Development", "Cybersecurity", "IT Support"],
    website: "https://reliableitservices.ca",
    image: "/companies/it-solutions.jpg",
    color: "primary"
  },
  {
    id: 2,
    name: "Reliable Home Care",
    description: "Complete home maintenance services including snow removal, grass cutting, landscaping, and seasonal property maintenance.",
    icon: "Home",
    features: ["Snow Removal", "Lawn Care", "Landscaping", "Maintenance"],
    website: "https://reliablehomecareservices.ca",
    image: "/companies/home-care.jpg",
    color: "accent"
  },
  {
    id: 3,
    name: "Reliable Auto Care",
    description: "Professional automotive detailing and care services to keep your vehicle looking pristine inside and out.",
    icon: "Car",
    features: ["Interior Detailing", "Exterior Wash", "Paint Protection", "Mobile Service"],
    website: "https://reliableautocare.ca",
    image: "/companies/auto-care.jpg",
    color: "primary"
  }
  // Party planning service hidden for now
  // {
  //   id: 4,
  //   name: "Reliable Party Planning",
  //   description: "Full-service event planning and party coordination for all occasions, from intimate gatherings to large celebrations.",
  //   icon: "Calendar",
  //   features: ["Event Planning", "Venue Coordination", "Catering Services", "Entertainment"],
  //   website: "https://reliablepartyplanning.com",
  //   color: "accent"
  // }
];

export const testimonials = [
  {
    id: 1,
    name: "Saad Ahmed",
    company: "South Park Driving School & Rannaghar Restaurant",
    text: "Reliable IT Solutions has been exceptional in supporting both of my businesses. They built custom websites for both companies, developed a mobile app for our driving school, and completely transformed our IT systems - from point-of-sale setup to network management. Professional, reliable, and always available when we need them. Highly recommend their digital services!",
    rating: 5,
    service: "IT Solutions"
  },
  {
    id: 2,
    name: "Jennifer Thompson",
    company: "Thompson Family",
    text: "We've been using Reliable Home Care for three years now - snow removal in winter, lawn maintenance in summer, and seasonal cleanups. They're incredibly dependable and our property always looks fantastic. Great communication and fair pricing!",
    rating: 5,
    service: "Home Care"
  },
  {
    id: 3,
    name: "David Marshall",
    company: "Marshall Auto Group",
    text: "Reliable Auto Care takes care of our entire fleet of vehicles. Their mobile service is a game-changer - they come to us! Professional detailing, paint protection, and maintenance. Our cars always look showroom ready. Excellent service!",
    rating: 5,
    service: "Auto Care"
  },
  {
    id: 4,
    name: "Maria Santos",
    company: "Santos Family Home",
    text: "After trying several lawn care companies, Reliable Home Care is by far the best! They transformed our overgrown yard into a beautiful landscape. Their snow removal service is prompt and thorough. Great value for money!",
    rating: 5,
    service: "Home Care"
  },
  {
    id: 5,
    name: "Amanda Burke",
    company: "Burke Family",
    text: "Reliable Auto Care detailed my SUV and it looked brand new! They even came to my workplace for the service. Attention to detail is incredible and the pricing is very reasonable. Will definitely use them again!",
    rating: 5,
    service: "Auto Care"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How do I book services with your subsidiary companies?",
    answer: "Each service company can be contacted directly through their dedicated websites. Click on any service card above to be redirected to the specific company's booking page and contact information."
  },
  {
    id: 2,
    question: "Do you offer bundled services across multiple companies?",
    answer: "Yes! As a parent company, we can coordinate services across our subsidiaries to provide you with comprehensive solutions. Contact our main office for custom package deals."
  },
  {
    id: 3,
    question: "What areas do you serve?",
    answer: "Our companies serve the greater metropolitan area and surrounding regions. Each subsidiary may have specific service areas - please check with the individual company for detailed coverage information."
  },
  {
    id: 4,
    question: "Do you offer emergency services?",
    answer: "Yes! Our IT Solutions company offers 24/7 emergency support, and our Home Care service provides emergency snow removal and property maintenance. Contact the specific company directly for urgent needs."
  }
];